import { Navigate, useLocation } from "react-router-dom";
import BlogArticlePage from "@/components/BlogArticlePage";
import { getBlogArticleBySlug } from "@/data/seoContent.mjs";

export default function GeneratedBlogArticle() {
  const location = useLocation();
  const article = getBlogArticleBySlug(location.pathname);

  if (!article) {
    return <Navigate to="/blog" replace />;
  }

  return <BlogArticlePage {...article} />;
}
